import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import Api from "@/common/api.helper";

import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
Vue.use(NProgress);
NProgress.configure({
  showSpinner: false
});

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  NProgress.set(0.1);
  /*if (!localStorage.getItem('token')) {    
    next({ name: "Login" });
    return;
  }*/

  if (to.name !== "Login" && to.name !== "Home" && to.name !== "NovoPlano" && to.name !== "RecuperarSenha" &&to.name !== "FirstLogin"&& to.name !== "Compras") {
    if (localStorage.getItem('token') && localStorage.getItem('user-token')) {
      var path = null
      if (to.path.substr(0, 8) == "/eventos") {
        path = "/eventos"
      } else if (to.path.substr(0, 5) == "/atas") {
        path = "/atas"
      } else if (to.path.substr(0, 13) == "/meus_eventos" || to.path == "/meus_documentos" || to.path == "/meus_reembolsos" || to.path == "/minhas_mensagens") {
        path = "/meu_titulo"
      } else {
        path = to.path
      }

      Api.get("/clubes/valid-token/" + localStorage.getItem('token') + "?user-token=" + localStorage.getItem('user-token') + "&path=" + path)
        .then(response => {
          if (response.data.length) {
            next();
          } else {
            //window.history.back();
            //next({ name: "login" });
            NProgress.done();
            Vue.$toast.warning("Acesso não autorizado.");
            // Vue.$router.push({ name: "Login"})            
            return;
          }
        })
        .catch(err => {
          let slug = JSON.parse(localStorage.getItem("clube-atual")).clube_slug;
          localStorage.removeItem("token");
          localStorage.removeItem("user-token");
          localStorage.removeItem("clubes");
          localStorage.removeItem("clube-atual");
          Vue.$toast.warning("Acesso não autorizado.");
          next({ name: "Login", params: { clubeSlug: slug } });
          throw err;
        })
    } else {
      let slug = JSON.parse(localStorage.getItem("clube-atual")).clube_slug;
      localStorage.removeItem("token");
      localStorage.removeItem("user-token");
      localStorage.removeItem("clubes");
      localStorage.removeItem("clube-atual");
      Vue.$toast.warning("Acesso não autorizado.");
      next({ name: "Login", params: { clubeSlug: slug } });
      return;
    }
    return;
  }
  next();
});

router.afterEach(() => {
  NProgress.set(0.9);
  //NProgress.done();
  setTimeout(() => NProgress.done(), 500)
})

export default router;
